/**
 * Panel definitions for flex/generation segment.
 */
import { applyCountryFilterToPanels } from './countryContext';

const entsoePanels = [
  {
    id: 'entsoe-generation-mix-comparison',
    type: 'datasetChart',
    datasetId: 'entsoe-generation',
    visualizationId: 'entsoe-generation-mix-comparison',
    gridPos: { x: 0, y: 0, w: 24, h: 11 },
  },
  {
    id: 'entsoe-generation-heatmap',
    type: 'datasetChart',
    datasetId: 'entsoe-generation',
    visualizationId: 'entsoe-generation-heatmap',
    gridPos: { x: 0, y: 11, w: 24, h: 18 },
  },
];

const nlWeatherPanels = [
  {
    id: 'knmi-weather-solar-radiation-heatmap',
    type: 'datasetChart',
    datasetId: 'knmi-weather',
    visualizationId: 'knmi-weather-solar-radiation-heatmap',
    gridPos: { x: 0, y: 29, w: 24, h: 15 },
  },
  {
    id: 'knmi-weather-wind-speed-heatmap',
    type: 'datasetChart',
    datasetId: 'knmi-weather',
    visualizationId: 'knmi-weather-wind-speed-heatmap',
    gridPos: { x: 0, y: 44, w: 24, h: 15 },
  },
];

const clonePanels = (panels) => panels.map((panel) => ({ ...panel, gridPos: { ...panel.gridPos } }));

export const flexGenerationPanels = ({ country } = {}) => [
  ...applyCountryFilterToPanels(entsoePanels, country),
  ...(country === 'NL' ? clonePanels(nlWeatherPanels) : []),
];
